import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Checkbox } from '@mui/material';

export const OfferPartnerIncomeTypeSummary = ({ incomeTypes }) => {
  return (
    <div>
      {incomeTypes.map((income, index) => {
        return (
          <Grid container key={index}>
            <Grid item xs={12} sm={12} md={4}>
              <Checkbox style={{ paddingLeft: '0px' }} checked={true} value='1' disabled={true} />
              <span>{income.name}</span>
            </Grid>
          </Grid>
        );
      })}
    </div>
  );
};

OfferPartnerIncomeTypeSummary.propTypes = {
  incomeTypes: PropTypes.array.isRequired
};

export default OfferPartnerIncomeTypeSummary;
